import { useCallback, useEffect, useState } from 'react'
import { kanbify } from '../lib/kanbifyClient'

export default function useCardWatch(cardId, userId) {
    const [watchRowId, setWatchRowId] = useState(null)
    const [loading, setLoading] = useState(true)
    const [saving, setSaving] = useState(false)

    useEffect(() => {
        let cancelled = false
        if (!cardId || !userId) return () => { cancelled = true }

        kanbify
            .from('notifications')
            .select('id')
            .eq('user_id', userId)
            .eq('card_id', cardId)
            .eq('type', 'card_watch')
            .limit(1)
            .maybeSingle()
            .then(({ data }) => {
                if (cancelled) return
                setWatchRowId(data?.id || null)
                setLoading(false)
            })

        return () => { cancelled = true }
    }, [cardId, userId])

    const toggleWatch = useCallback(async () => {
        if (!cardId || !userId || saving) return { success: false }
        setSaving(true)
        if (watchRowId) {
            const { error } = await kanbify.from('notifications').delete().eq('id', watchRowId)
            if (!error) setWatchRowId(null)
            setSaving(false)
            return { success: !error, error: error?.message }
        }

        const id = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`
        const { error } = await kanbify.from('notifications').insert([{
            id,
            user_id: userId,
            type: 'card_watch',
            title: 'Watch',
            body: '',
            icon: 'W',
            card_id: cardId,
            is_read: true,
        }])
        if (!error) setWatchRowId(id)
        setSaving(false)
        return { success: !error, error: error?.message }
    }, [cardId, saving, userId, watchRowId])

    return { watched: Boolean(watchRowId), loading, saving, toggleWatch }
}
